/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
'use es6';

import * as AttributesApi from '../api/attributes';
import getQuickFetchRequestPromise from 'DesignData/api/getQuickFetchRequestPromise';
import { RECEIVE_ATTRIBUTES_META } from 'DesignData/actions/ActionTypes';
export function receiveAttributesMeta(response) {
  const {
    designManagerUserSettings,
    reactCodeMirrorSettings
  } = response;
  return Object.assign({}, response, {
    type: RECEIVE_ATTRIBUTES_META,
    designManagerUserSettings: designManagerUserSettings || {},
    reactCodeMirrorSettings: reactCodeMirrorSettings || {}
  });
}
export function fetchAttributesMeta() {
  return dispatch => {
    const successHandler = response => {
      dispatch(receiveAttributesMeta(response));
    };

    const quickFetchPromise = getQuickFetchRequestPromise('attributes-meta', AttributesApi.fetchAttributesMeta);

    if (quickFetchPromise) {
      quickFetchPromise.then(successHandler);
      return;
    }

    AttributesApi.fetchAttributesMeta().then(successHandler);
  };
}